import { routes } from '@/shared/routes'

type FooterMenuType = {
  id: number
  title: string
  links: {
    id: number
    title: string
    href: string
    target: string
    isDisabled: boolean
    function?: () => void
  }[]
}

export const footerMenuMock: FooterMenuType[] = [
  {
    id: 1,
    title: 'Emissores',
    links: [
      { id: 1, title: 'NFe', href: routes.NFE, target: '', isDisabled: false },
      {
        id: 2,
        title: 'NFCe',
        href: routes.NFCE,
        target: '',
        isDisabled: false,
      },
      { id: 3, title: 'CTe', href: routes.CTE, target: '', isDisabled: false },
      {
        id: 4,
        title: 'MDFe',
        href: routes.MDFE,
        target: '',
        isDisabled: true,
      },
    ],
  },
  {
    id: 2,
    title: 'Ecossistema',
    links: [
      {
        id: 1,
        title: 'Certificado Digital',
        href: 'https://lp.nosso.pro/loja/checkout?p=u828-treeunfe-informatica-ltda&item=eyJyYW5kIjoiMTczNzM0NjcwOTI5NTIiLCJpZCI6MTk2fQ==',
        target: '_blank',
        isDisabled: false,
      },
    ],
  },
  {
    id: 3,
    title: 'Ferramentas Gratuitas',
    links: [
      {
        id: 1,
        title: 'Leitor de XML',
        href: '#',
        target: '',
        isDisabled: true,
      },
      { id: 2, title: 'Consulta NCM', href: '#', target: '', isDisabled: true },
      {
        id: 3,
        title: 'Calculadora DIFAL',
        href: '#',
        target: '',
        isDisabled: true,
      },
      {
        id: 4,
        title: 'Consulta CEST',
        href: '#',
        target: '',
        isDisabled: true,
      },
      {
        id: 5,
        title: 'Consulta CFOP',
        href: '#',
        target: '',
        isDisabled: true,
      },
    ],
  },
  {
    id: 5,
    title: 'A Treeunfe',
    links: [
      {
        id: 1,
        title: 'Quem somos',
        href: routes.ABOUT_US,
        target: '',
        isDisabled: false,
      },
      {
        id: 2,
        title: 'Trabalhe conosco',
        href: routes.WORK_WITH_US,
        target: '',
        isDisabled: false,
      },
      {
        id: 3,
        title: 'Histórias de clientes',
        href: `${routes.HOME}#trusted-by`,
        target: '',
        isDisabled: false,
      },
      {
        id: 4,
        title: 'Novidades',
        href: '#',
        target: '',
        isDisabled: false,
        function: () => {
          window.Intercom?.('showNews')
        },
      },
    ],
  },
  {
    id: 6,
    title: 'Confie em nós',
    links: [
      {
        id: 1,
        title: 'Central de Confiança',
        href: routes.TRUTUS,
        target: '',
        isDisabled: false,
      },
      {
        id: 2,
        title: 'Privacidade',
        href: routes.TRUTUS_PRIVACY,
        target: '',
        isDisabled: false,
      },
    ],
  },
  {
    id: 7,
    title: 'Conteúdos',
    links: [
      {
        id: 1,
        title: 'Blog',
        href: routes.BLOG,
        target: '',
        isDisabled: false,
      },
      { id: 2, title: 'E-books', href: '#', target: '', isDisabled: true },
      { id: 3, title: 'Webinares', href: '#', target: '', isDisabled: true },
      { id: 4, title: 'Podcasts', href: '#', target: '', isDisabled: true },
      { id: 5, title: 'Relatórios', href: '#', target: '', isDisabled: true },
    ],
  },
  {
    id: 8,
    title: 'Atendimento',
    links: [
      {
        id: 1,
        title: 'Central de Ajuda',
        href: 'https://ajuda.treeunfe.com.br/pt-BR/',
        target: '_blank',
        isDisabled: false,
      },
      {
        id: 2,
        title: 'Tutoriais em vídeo',
        href: 'https://www.youtube.com/@Treeunfe/playlists',
        target: '_blank',
        isDisabled: false,
      },
      {
        id: 3,
        title: 'Fale Conosco',
        href: '#',
        target: '',
        isDisabled: false,
        function: () => {
          window.Intercom?.('showNewMessage', 'Olá, gostaria de falar com um especialista.')
        },
      },
    ],
  },
]
